/**
 * Search overlay.
 */
if (!customElements.get('search-overlay')) {
  customElements.define(
    'search-overlay',
    class SearchOverlay extends HTMLElement {
      connectedCallback() {
        this.setNodeSelectors();
        this.setEventListeners();
        this.setViewAllClickEvent();
        this.setProductGroupEvents();
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          input: this.querySelector('[js-search-overlay="input"]'),
          form: this.querySelector('[js-search-overlay="form"]'),
          viewAll: this.querySelector('[js-search-overlay="viewAll"]'),
        };
      }

      /**
       * Sets node selectors and events for product group toggling.
       */
      setProductGroupEvents() {
        this.nodeSelectors.productGroupToggles = this.querySelectorAll('[js-search-overlay="productGroupToggle"]');
        this.nodeSelectors.productGroups = this.querySelectorAll('[js-search-overlay="productGroup"]');

        [...this.nodeSelectors.productGroupToggles].forEach((element) => {
          element.addEventListener('mouseenter', (event) => {
            if (!window.matchMedia(`(min-width: 1024px)`).matches) {
              return;
            }

            const productGroup = [...this.nodeSelectors.productGroups].find(
              (products) => products.dataset.productGroup === event.target.dataset.productGroup
            );

            if (!productGroup) return;

            [...this.nodeSelectors.productGroups].forEach((products) => {
              if (products.dataset.productGroup === event.target.dataset.productGroup) {
                products.classList.remove('is-hidden');
                event.target.classList.add('is-active');
                return;
              }

              products.classList.add('is-hidden');

              const inactiveToggle = [...this.nodeSelectors.productGroupToggles].find(
                (toggle) => toggle.dataset.productGroup === products.dataset.productGroup
              );

              if (inactiveToggle) {
                inactiveToggle.classList.remove('is-active');
              }
            });
          });
        });
      }

      /**
       * Sets the view all click event.
       */
      setViewAllClickEvent() {
        const element = this.querySelector('[js-search-overlay="viewAll"]');

        if (element && this.nodeSelectors.form) {
          element.addEventListener('click', () => this.nodeSelectors.form.submit());
        }
      }

      /**
       * Sets the event listeners.
       */
      setEventListeners() {
        if (this.nodeSelectors.input) {
          this.nodeSelectors.input.addEventListener('keyup', debounce(this.handleInputKeyup).bind(this));
        }

        theme.eventBus.listen('ToggleElement:opening', (namespace) => {
          if (namespace === 'search-overlay') {
            this.handleInputKeyup();
          }
        });
      }

      /**
       * Handls the search input keyup event.
       * @param {Event} event - The event payload.
       */
      handleInputKeyup(event) {
        const query = event ? event.target.value : this.nodeSelectors.input.value;
        let endpoint = `${theme.routes.predictive_search_url}?q=${query}&section_id=${this.dataset.sectionId}`;

        if (query === '') {
          /**
           * If the query is empty, render the default state.
           */
          endpoint = `${theme.routes.root_url}?section_id=${this.dataset.sectionId}`;
        }

        if (this.currentController) {
          /**
           * Cancel the previous request.
           */
          this.currentController.abort('Aborted pending search');
        }

        this.currentController = new AbortController();

        fetch(endpoint, {
          signal: this.currentController.signal,
        })
          .then((response) => response.text())
          .then((response) => {
            const html = new DOMParser().parseFromString(response, 'text/html');
            const main = html.querySelector('search-overlay');

            if (!main) {
              return;
            }

            replaceElement(this, main, '[js-search-overlay="results"]');
            replaceElement(this, main, '[js-search-overlay="collections"]');
            replaceElement(this, main, '[js-search-overlay="footer"]');

            setAllDynamicImages(this);

            this.setViewAllClickEvent();
            this.setProductGroupEvents();
          })
          .catch(() => {});
      }
    }
  );
}
